import { MetricOption, MetricType } from 'components/common/types/DrilldownReports.types';

export const metricTypeToName: Record<MetricType, string> = {
  [MetricType.IMPRESSIONS]: 'Impressions',
  [MetricType.FRAMES]: 'Frames',
  [MetricType.SOT]: 'SOT',
  [MetricType.PRICE_GROSS]: 'Price (Gross)',
  [MetricType.PRICE_INDEXED]: 'Price (Indexed)',
};

export const metricOptions: MetricOption[] = [
  { name: metricTypeToName[MetricType.IMPRESSIONS], code: MetricType.IMPRESSIONS },
  { name: metricTypeToName[MetricType.FRAMES], code: MetricType.FRAMES },
  { name: metricTypeToName[MetricType.SOT], code: MetricType.SOT },
];

export const allocationMetricOptions: MetricOption[] = [
  ...metricOptions,
  { name: metricTypeToName[MetricType.PRICE_GROSS], code: MetricType.PRICE_GROSS },
  { name: metricTypeToName[MetricType.PRICE_INDEXED], code: MetricType.PRICE_INDEXED },
];
